import React from 'react';

import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import Placeholder from '@atlassian/jira-placeholder';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { PACKAGE_NAME, TEAM_NAME } from '../../common/constants.tsx';
import { useIsEligibleForTrialAssistantWelcome } from '../../services/eligibility-check/index.tsx';
import type UpgradeModalWrapperType from './index.tsx';

const AsyncWelcomeModal = lazyAfterPaint<typeof UpgradeModalWrapperType>(() =>
	import(/* webpackChunkName: "async-jira-trial-assistant-upgrade-modal" */ './index.tsx').then(
		(module) => module.WelcomeModalWrapper,
	),
);

const JiraTrialAssistantWelcomeModal = () => {
	const isEligible =
		useIsEligibleForTrialAssistantWelcome() &&
		expValEquals('custom_rovo_onboarding_agent', 'cohort', 'variation', 'not-enrolled');

	const triggerRovo = () => {
		// TODO: LUNA-648 Configure OOTB Rovo Trigger
	};

	if (!isEligible) {
		return <></>;
	}

	return (
		<JSErrorBoundary
			id="JiraTrialAssistantWelcomeModal"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
			fallback="unmount"
		>
			<UFOSegment name="jira-trial-assistant-welcome-modal">
				<Placeholder name="jira-trial-assistant-welcome-modal" fallback={null}>
					<AsyncWelcomeModal onPrimaryCta={triggerRovo} />
				</Placeholder>
			</UFOSegment>
		</JSErrorBoundary>
	);
};

// Note: this component is renamed at export to avoid the term "Modal",
// which often correlates to an entry point. This UI opens automatically and not via trigger.
export const JiraTrialAssistantWelcomeAutoPopup = JiraTrialAssistantWelcomeModal;
